/**
 * Hook to detect if the app is running in Lovable preview mode.
 * Admin features are ONLY available in preview mode, not on published sites.
 * This eliminates the login page attack surface on production.
 */
export function useIsPreviewMode(): boolean {
  const hostname = window.location.hostname;
  
  // Lovable preview domains
  const isLovablePreview = 
    hostname.includes('lovableproject.com') || 
    hostname.includes('lovable.app') ||
    hostname === 'localhost' || 
    hostname === '127.0.0.1';
  
  return isLovablePreview;
}

/**
 * Non-hook version for use outside React components
 */
export function isPreviewMode(): boolean {
  const hostname = window.location.hostname;
  
  return (
    hostname.includes('lovableproject.com') || 
    hostname.includes('lovable.app') ||
    hostname === 'localhost' || 
    hostname === '127.0.0.1'
  );
}
